import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import {
	Autocomplete,
	Box,
	DialogContent,
	FormControl,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	TextField,
	Typography,
} from '@mui/material';
import { AutocompleteTextField } from 'ui/AutocompleteTextField';
import { set } from 'lodash';
import {
	createSwissPostRequest,
	getSwissPostAvailableEmsRequest,
} from 'redux/reducers/swissPost/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getSwissPostAvailableEms } from 'redux/reducers/swissPost/selectors';
import { CountrySelect } from 'ui/CountrySelect';
import { CountrySelectMenu } from 'ui/CountrySelectMenu';
import { getEMerchant } from 'redux/reducers/monthlyFee/selectors';
import { PAGE_SIZE } from 'services/constants/env';
import { useNavigate } from 'react-router';
import {
	markAsProcessedRequest,
	searchInvoiceRequest,
	searchInvoiceSuccess,
} from 'redux/reducers/swedBank/reducer';
import { searchInvoices } from 'redux/reducers/swedBank/selectors';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { TMarkAsProcessedDialogProps } from './types';
import { InvoicesTableTable } from './InvoicesTableTable';

export const MarkAsProcessedDialog: FC<TMarkAsProcessedDialogProps> = ({
	open,
	setClose,
	data,
	incomingPaymentId,
	swedBankIntegrationRequest,
}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const emList = useSelector(getEMerchant);
	const emListFullNames = emList?.map(item => item.fullName);
	const [em, setEm] = useState<string | null>(null);
	const [inputEm, setInputEm] = useState('');
	const [invoiceNumber, setInvoiceNumber] = useState<string | null>(null);
	const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState<number | null>(null);
	const searchInvoiceList = useSelector(searchInvoices);

	const handleInvoiceNumber = (event: any) => {
		setSelectedInvoiceNumber(null);
		setEm(null);
		setInvoiceNumber(event.target.value);
		dispatch(searchInvoiceRequest({ emId: null, invoiceNumber: +event.target.value }));
	};

	const handleChangeEm = (event: any, newValue: string | null) => {
		setSelectedInvoiceNumber(null);
		setEm(newValue);
		setInputEm(newValue ?? '');
		const emId = emList?.find(item => item.fullName === newValue)?.id;
		if (!emId) return;
		setInvoiceNumber(null);
		dispatch(searchInvoiceRequest({ emId, invoiceNumber: null }));

		// const params: TMonthlyFeeListRequestPayload = {
		// 	pageNumber: +(pageNumber || 1),
		// 	pageSize: PAGE_SIZE,
		// 	emId,
		// };

		// dispatch(getMonthlyFeeListRequest(params));
		// if (!newValue) return;
		// navigate({
		// 	pathname: location.pathname,
		// 	search: `?pageNumber=${String(currentPage)}${em ? `&emId=${String(emId)}` : ''}`,
		// });
		// setCurrentPage(1);
	};

	useEffect(() => {
		// if (!open) return;
		// if (!data) return;
		// setAddress(data.shipper_address);
		// setCity(data.shipper_city);
		// setIossProjectId(String(data.msg_project_id_ioss));
		// setDdpProjectId(String(data.msg_project_id_oss));
		// setZipCode(data.shipper_zip_code);
		// setCountryIso2Code(data.shipper_country_iso_code);
		// setDefaultHs6Code(data.default_hs6_code);
	}, [data, open]);

	const reset = () => {
		setEm(null);
		setInvoiceNumber(null);
		setSelectedInvoiceNumber(null);
		dispatch(searchInvoiceSuccess(null));
	};

	const handleClickConnect = () => {
		if (selectedInvoiceNumber === null) return;
		if (searchInvoiceList === null) return;

		dispatch(
			markAsProcessedRequest({
				body: {
					incomingPaymentId,
					type: 'attached',
					invoiceNumber: searchInvoiceList[selectedInvoiceNumber].invoiceNumber,
				},
				swedBankIntegrationRequest,
			}),
		);
		reset();
		setClose();
	};

	const handleClickMarkAsPaid = () => {
		if (selectedInvoiceNumber === null) return;
		if (searchInvoiceList === null) return;

		dispatch(
			markAsProcessedRequest({
				body: {
					incomingPaymentId,
					type: 'paid',
					invoiceNumber: searchInvoiceList[selectedInvoiceNumber].invoiceNumber,
				},
				swedBankIntegrationRequest,
			}),
		);
		reset();
		setClose();
	};

	if (!data) return null;

	return (
		<Dialog
			open={open}
			// onClose={setClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle
				color="primary"
				sx={{
					padding: '10px 20px 0 20px',
				}}
			>
				Mark as Processed
				{/* <AmountAndCurrency
						amount={data.amount}
						currency={data.currency}
						size={1}
						bold
						color="primary"
					/> */}
			</DialogTitle>
			<DialogContent>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: 2,
						// width: '500px',
						minWidth: '480px',
						maxWidth: '900px',
						padding: '10px 0 0 0',
					}}
				>
					{/* <Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							gap: 1,
						}}
					>
						<Typography variant="body2" color="primary">
							Reg Num:
						</Typography>
						<Typography
							variant="body1"
							color="primary"
							sx={{
								fontWeight: 'bold',
							}}
						>
							{data.endToEndId}
						</Typography>
					</Box>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							gap: 1,
						}}
					>
						<Typography variant="body2" color="primary">
							Payment Description:
						</Typography>
						<Typography
							variant="body1"
							color="primary"
							sx={{
								fontWeight: 'bold',
							}}
						>
							{data.paymentInformation}
						</Typography>
					</Box> */}
					<Box
						sx={{
							// border: '1px solid #016193',
							padding: 1,
							margin: '0 0 10px 0',
							borderRadius: '12px',
							backgroundColor: 'primary.light',
						}}
					>
						<TableContainer>
							<Table>
								<TableBody>
									<TableRow>
										<TableCell
											color="primary"
											sx={{
												fontSize: '0.7rem',
												color: 'primary.main',
												padding: '0 8px 8px 0',
												border: 0,
											}}
										>
											Amount:
										</TableCell>
										<TableCell
											sx={{
												fontSize: '0.8rem',
												fontWeight: 'bold',
												color: 'primary.main',
												padding: '0 0 8px 0',
												border: 0,
											}}
										>
											<AmountAndCurrency
												amount={data.amount}
												currency={data.currency}
												size={0.8}
												bold="bold"
												color="primary"
											/>
										</TableCell>
									</TableRow>

									<TableRow>
										<TableCell
											color="primary"
											sx={{
												fontSize: '0.7rem',
												color: 'primary.main',
												padding: '0 8px 8px 0',
												border: 0,
												verticalAlign: 'top',
											}}
										>
											Reg Num:
										</TableCell>
										<TableCell
											sx={{
												fontSize: '0.8rem',
												fontWeight: 'bold',
												color: 'primary.main',
												padding: '0 0 8px 0',
												border: 0,
											}}
										>
											{data.endToEndId}
										</TableCell>
									</TableRow>
									<TableRow>
										<TableCell
											color="primary"
											sx={{
												fontSize: '0.7rem',
												color: 'primary.main',
												padding: '0 8px 0 0',
												border: 0,
												verticalAlign: 'top',
											}}
										>
											Description:
										</TableCell>
										<TableCell
											sx={{
												fontSize: '0.8rem',
												fontWeight: 'bold',
												color: 'primary.main',
												padding: '0px',
												border: 0,
											}}
										>
											{data.paymentInformation}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>
					</Box>

					<Autocomplete
						id="monthly-fee-input"
						options={emListFullNames ?? []}
						sx={{ width: '100%' }}
						renderInput={params => (
							<TextField
								{...params}
								label="Search EM"
								variant="outlined"
								sx={{ bgcolor: 'white', borderRadius: '5px' }}
								// hiddenLabel={false}
								placeholder="Search EM"
								size="small"
							/>
						)}
						value={em}
						onChange={handleChangeEm}
					/>
					<TextField
						label="Search Invoice"
						variant="outlined"
						sx={{ bgcolor: 'white', borderRadius: '5px' }}
						// hiddenLabel={false}
						placeholder="Search Invoice"
						size="small"
						fullWidth
						onChange={handleInvoiceNumber}
						value={invoiceNumber}
					/>

					<InvoicesTableTable
						selectedInvoiceNumber={selectedInvoiceNumber}
						setSelectedInvoiceNumber={setSelectedInvoiceNumber}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'right',
						padding: '10px',
						alignItems: 'end',
						flexDirection: 'row',
						gap: 0,
					}}
				>
					<Button
						sx={{
							textTransform: 'none',
						}}
						onClick={() => {
							reset();
							setClose();
						}}
					>
						Cancel
					</Button>

					<Button
						sx={{
							textTransform: 'none',
						}}
						onClick={handleClickConnect}
						autoFocus
						disabled={selectedInvoiceNumber === null}
					>
						Connect to paid Invoice
					</Button>
					{/* <Button
						sx={{
							textTransform: 'none',
						}}
						onClick={handleClickConnect}
						autoFocus
						disabled={selectedInvoiceNumber === null}
					>
						Add to paid invoice
					</Button> */}
					<Button
						sx={{
							textTransform: 'none',
						}}
						onClick={handleClickMarkAsPaid}
						autoFocus
						disabled={selectedInvoiceNumber === null}
					>
						Mark as paid
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};
